import constants from 'constants/constants';
import moment from 'moment-timezone';

export const isFiltersContainStatusChanged = (filterList: {
    filter: { filters: { data: string | number[]; name: string } }[];
}): boolean => {
    if (filterList?.filter && filterList?.filter.filters) {
        const filtersObj = filterList?.filter.filters;
        const statusFilter = filtersObj.find((filterArr) => filterArr.name === 'STATUS_CARD_BOARD');
        if (!statusFilter) return false;
        return statusFilter.data.findIndex((status: string) => status === 'INTERIM_CHANGED') > -1;
    }
    return false;
};

export const getFilterData = (source, name: string) => {
    return source.filterData?.filter.filters.find((item) => item.name === name)?.data ?? null;
};

export const getDateFilters = (source, name: string, flag: string) => {
    const value = getFilterData(source, name);
    return value
        ? value.length === 0
            ? source.filterData.flags[flag]
            : value.map((item) => moment(Number(item)).format(constants.formats.date.default))
        : null;
};

export const getBooleanFilters = (source, name: string) => {
    const value = getFilterData(source, name);
    return value ? (value[0] === '1' ? 'Yes' : 'No') : null;
};
